import { testConnectorConfigDialfireDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const testConnectorConfigDialfireCallable = getCallable(
  testConnectorConfigDialfireDefinition,
);
